/* 产引入jsencrypt实现数据RSA加密 */
/// 渗透测试中，此包报版本过低问题
// import JSEncrypt from 'jsencrypt' // 处理长文本数据时报错 jsencrypt.js Message too long for RSA
import JSEncrypt from '../utils/jsencrypt.min'
/* 产引入encryptlong实现数据RSA加密 */
// import Encrypt from 'encryptlong' // encryptlong是基于jsencrypt扩展的长文本分段加解密功能。

// 公钥key
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQh2KhjtVmLrgeZImy5as5abcsPMDlnb4E1x0T5+4TWW8RCs3yjO5LQ7sqQp7EirX6/VQRwg67bKxR1OeaMID3d0MPsFWPhWr+6Rxm06s5YPvZX8VJ7EfDP047X2qxdUuv/GvfntwYq2s+Oq7RVjOUM7zVEIuSB1/9TTohKKvwswIDAQAB'

const privateKey = 'MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAJCHYqGO1WYuuB5kibLlqzlptyw8wOWdvgTXHRPn7hNZbxEKzfKM7ktDuypCnsSKtfr9VBHCDrtsrFHU55owgPd3Qw+wVY+Fav7pHGbTqzlg+9lfxUnsR8M/TjtfarF1S6/8a9+e3Biraz46rtFWM5QzvNUQi5IHX/1NOiEoq/CzAgMBAAECgYBLBjxo6SBVnsLs4/um5hnv/7SaPh9UEoJlONVbU/X+DVreWeF2mznH0C0ETvjjxa2Z0I8neLj1CgCZqg9ftvX6uDXk+9AiuDnEv/Wo/tO/n7LkdkGZwF5ERdp2MUSbYHdzS2G5ledZye4WxD8bFmoNj2nGYyU+XQpSLWBB4etj4QJBAMFBu9dybWMvQEL6DLOJSGav7FHEsmQvP5wmk7tXd6l//mDqXICr/bvZq1ar3JB5DkrcgiZFOjw6EAZB5qEtKHUCQQC/c7LFA0qGbrJTOIdNRuK26frFiUaT/C9yZwuDugjn247pN15mFvGovpFl8FwA9OrLLDE587zC/GUTyAtQ8c+HAkAuu56Y8urQ2VRI3f7ES6ZebpxPCam54FMZh5qh6vzc2D7DYOkNlIm/K1vrkZO8vAlgwQIYDxWOCtxlJvqGb00hAkBx/EWEbMgzL7b2O2K7DKgwtS/76hZeRzhMibNeUyW4PY1hpviKGcD5cbSJl8h/PVKJcp9AXLCW+sSHOYQbRk0DAkBa8pYowlrpGuow5v7zkGBdve/xGxGhtEXJbHqHrcuzdAhTxLsYgC2GMcHtHijGmSKtVg4wajsdIXvivZ9XFa/1'
export default {
  /* JSEncrypt加密 */
  rsaPublicData (data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPublicKey(publicKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.encrypt(data)
    return result
  },
  /* JSEncrypt解密 */
  rsaPrivateData (data) {
    var jsencrypt = new JSEncrypt()
    jsencrypt.setPrivateKey(privateKey)
    // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
    var result = jsencrypt.decrypt(data)
    return result
  }
  // /* 加密 */
  // encrypt (data) {
  //   const PUBLIC_KEY = publicKey
  //   var encryptor = new Encrypt()
  //   encryptor.setPublicKey(PUBLIC_KEY)
  //   // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
  //   const result = encryptor.encryptLong(data)
  //   return result
  // },
  // /* 解密 - PRIVATE_KEY - 验证 */
  // decrypt (data) {
  //   const PRIVATE_KEY = publicKey
  //   var encryptor = new Encrypt()
  //   encryptor.setPrivateKey(PRIVATE_KEY)
  //   // 如果是对象/数组的话，需要先JSON.stringify转换成字符串
  //   var result = encryptor.decryptLong(data)
  //   console.log('result', result)

  //   return result
  // }
}
